// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3zsF3","title":"Info_title__2y6PU","links":"Info_links__28UMX","link":"Info_link__2pGuh","logo":"Info_logo__3x2w9"};